module.exports = __webpack_public_path__ + "assets/devices/SR-730-PG2-928e69647a575e4f7e9adc8f581da194.svg";